import { t } from 'i18next';
import { Button, Dialog, DialogProps, Paragraph } from '@expressable/syntax-ds';

export type RescheduleConfirmationResponse = 'success' | 'inactive' | 'notfound';

type Props = DialogProps & {
  onConfirm: () => void;
  status: RescheduleConfirmationResponse | null;
  isLoading?: boolean;
};

const RescheduleConfirmationModalMap = new Map([
  [
    'inactive',
    {
      title: t('reschedule.confirm.appointmentNoLongerValidTitle', 'We\'re sorry, the appointment you selected is no longer available.'),
      message: t('reschedule.confirm.appointmentNoLongerValidDescription', 'Please select a new slot you\'d like to reschedule your appointment.'),
      cta: t('reschedule.confirm.selectNewAppointment'),
    },
  ],
  [
    'notfound',
    {
      title: t('reschedule.confirm.rescheduleNotFoundTitle', 'Whoops! This link has expired.'),
      message: t('reschedule.confirm.rescheduleNotFoundDescription', 'Please text your therapist or contact our support team for assistance.'),
      cta: t('reschedule.confirm.selectNewAppointment'),
    },
  ],
  [
    'success',
    {
      title: t('reschedule.confirm.rescheduleSuccessTitle', 'Great! Your appointment has been rescheduled successfully.'),
      message: t('reschedule.confirm.rescheduleSuccessDescription', 'You\'re all set! You can now close this page or head back to your dashboard to see your updated appointment.'),
      cta: t('reschedule.confirm.rescheduleSuccessButton'),
    },
  ],
]);

export const RescheduleConfirmationDialog = ({ status, onConfirm, isLoading, ...dialogProps }: Props) => {
  if (!status) return null;
  return (
    <Dialog {...dialogProps}>
      <Dialog.Header>
        <Dialog.Title>{RescheduleConfirmationModalMap.get(status)?.title as string}</Dialog.Title>
      </Dialog.Header>
      <Dialog.Body>
        <Paragraph>{RescheduleConfirmationModalMap.get(status)?.message}</Paragraph>
      </Dialog.Body>
      <Dialog.CTAs>
        <Button onClick={onConfirm} disabled={isLoading}>
          {RescheduleConfirmationModalMap.get(status)?.cta}
        </Button>
      </Dialog.CTAs>
    </Dialog>
  );
};
